import {cx} from "@emotion/css";

import {designColors} from "~/ui";
import {ReactComponent as SvgVector} from "~/assets/svg/vector.svg";

import {simpleIconStyles} from "../styles";
import {commonStyles} from "../../_common/styles";
import {IIconBase} from "../../_common/types";

export const BmVectorIcon: React.FC<IIconBase> = ({id, size = "sm", color = designColors.black, className}) => {
  return <SvgVector id={id} className={cx(simpleIconStyles(size), commonStyles.color(color), className)} />;
};
